import React, { useEffect, useState } from "react"
import { IoMdCheckmark } from "react-icons/io"

const NotificationPopup = ({ message, onUndo, success }) => {
	const [scrollTop, setScrollTop] = useState(0)

	useEffect(() => {
		const updatePosition = () => {
			setScrollTop(window.scrollY)
		}

		window.addEventListener("scroll", updatePosition)
		updatePosition() // Initial position set when the component mounts

		return () => {
			window.removeEventListener("scroll", updatePosition)
		}
	}, [])

	return (
		<div
			className="absolute left-1/2 transform -translate-x-1/2 bg-[#252824] text-white px-6 py-3 rounded-md shadow-lg flex items-center z-[1002] max-w-[600px]"
			style={{ top: scrollTop + 16 }} // 16px from the top of the current viewport
		>
			<div className="flex items-center">
				<div className={`${success ? "bg-green-500" : "bg-red-500"} p-1 rounded-full mr-3`}>
					<IoMdCheckmark className="text-white text-lg" />
				</div>
				<span className="text-white font-semibold mr-12">{message}</span>
			</div>
			{/*<button onClick={onUndo} className="flex items-center text-gray-300 hover:text-gray-400 transition-colors duration-200 ml-auto">
                <IoIosArrowBack className="mr-1" />
                <span className="font-medium">Undo</span>
            </button>*/}
		</div>
	)
}

export default NotificationPopup
